export default __webpack_public_path__ + "static/media/fantasy-world.b8e7e81f.jpeg";